<template>

    <v-row no-gutters class="d-flex flex-column justify-center align-center">

        <v-col cols='1' class="d-flex flex-column justify-center align-center">

            <div class="display-1 deep-orange--text font-weight-bold clicks-total-sheets">{{showedData}}</div>

        </v-col>

        <v-col cols='3' class="d-flex flex-column justify-center align-center">

            <div class="display-1 font-weight-bold cyan--text text-center">CLIQUES</div>

        </v-col>

        <v-col v-if="!loading" class="d-flex justify-center mt-5">

            <click-data-sheet ref="face" class="mx-2 clicks-face-sheets" icon='mdi-facebook' sheetColor='blue' :clicks='faceClicks' />

            <click-data-sheet ref="whats" class="mx-2 clicks-whats-sheets" icon='mdi-whatsapp' sheetColor='green' :clicks='whatsClicks' />

            <click-data-sheet ref="phone" class="mx-2 clicks-phone-sheets" icon='mdi-phone' sheetColor='grey' :clicks='phoneClicks' />

            <click-data-sheet ref="web" class="mx-2 clicks-web-sheets" icon='mdi-web' sheetColor='pink' :clicks='websiteClicks' />

            <click-data-sheet ref="buynow" class="mx-2 clicks-web-sheets" icon='mdi-currency-usd' sheetColor='orange' :clicks='buynowClicks' />

        </v-col>

    </v-row>
    
</template>

<script>
import ClickDataSheet from '../utils/ClickDataSheet.vue'

export default {

    components: { ClickDataSheet },

    name: 'SheetsData',
    
    props: ['loading', 'showedData', 'faceClicks', 'whatsClicks', 'phoneClicks', 'websiteClicks', 'buynowClicks']

}
</script>
